export const BUILDINGS = {
  U1: { score: 60, adjacent: ['M1', 'M2', 'K1', 'K2'] },
  U2: { score: 48, adjacent: ['M2', 'M3', 'K2', 'K3'] },
  U3: { score: 24, adjacent: ['M3', 'M4', 'K3', 'K4'] },
  U4: { score: 24, adjacent: ['M4', 'M5', 'K4', 'K5'] },
  X1: { score: 12, adjacent: ['K1', 'K2', 'D1', 'D2'] },
  X2: { score: 24, adjacent: ['K2', 'K3', 'D2', 'D3'] },
  X3: { score: 48, adjacent: ['K3', 'K4', 'D3', 'D4'] },
  X4: { score: 12, adjacent: ['K4', 'K5', 'D4', 'D5'] },
  Y1: { score: 12, adjacent: ['D1', 'D2', 'L1', 'L2'] },
  Y2: { score: 48, adjacent: ['D2', 'D3', 'L2', 'L3'] },
  Y3: { score: 24, adjacent: ['D3', 'D4', 'L3', 'L4'] },
  Y4: { score: 12, adjacent: ['D4', 'D5', 'L4', 'L5'] },
  Z1: { score: 24, adjacent: ['L1', 'L2', 'W1', 'W2'] },
  Z2: { score: 24, adjacent: ['L2', 'L3', 'W2', 'W3'] },
  Z3: { score: 48, adjacent: ['L3', 'L4', 'W3', 'W4'] },
  Z4: { score: 60, adjacent: ['L4', 'L5', 'W4', 'W5'] }
} as const;

export const VALID_CELLS = [
  "M1", "M2", "M3", "M4", "M5",
  "K1", "K2", "K3", "K4", "K5",
  "D1", "D2", "D3", "D4", "D5",
  "L1", "L2", "L3", "L4", "L5",
  "W1", "W2", "W3", "W4", "W5"
] as const;

export const MAX_ROUNDS = 12;

export const GRID = [
  ['M1', '',   'M2', '',   'M3', '',   'M4', '',   'M5'], // Row 1
  ['',   'U1', '',   'U2', '',   'U3', '',   'U4', ''],   // Row 2
  ['K1', '',   'K2', '',   'K3', '',   'K4', '',   'K5'], // Row 3
  ['',   'X1', '',   'X2', '',   'X3', '',   'X4', ''],   // Row 4
  ['D1', '',   'D2', '',   'D3', '',   'D4', '',   'D5'], // Row 5
  ['',   'Y1', '',   'Y2','',   'Y3','',   'Y4',''],   // Row 6
  ['L1', '',   'L2', '',   'L3', '',   'L4', '',   'L5'], // Row 7
  ['',   'Z1','',   'Z2','',   'Z3','',   'Z4',''],   // Row 8
  ['W1', '',   'W2', '',   'W3', '',   'W4', '',   'W5']  // Row 9
] as const;
